const CART = 'shopify_local_store__cart'
const CHECKOUT_ID = 'shopify_local_store__checkout_id'
const USER = 'shopify_local_user'

export const LocalStorageKeys = {
  CART,
  CHECKOUT_ID,
  USER,
}
